export default __webpack_public_path__ + "maps-examples-fly-to-thumbnail-480-23f6dc75b3be6ffbe3e5eb960212b536.webp";